"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var diagnosis_web_socket_service_1 = require("../../service/diagnosis-web-socket.service");
var LastCoordinateDisplayComponent = /** @class */ (function () {
    function LastCoordinateDisplayComponent(_diagnosisNotification) {
        this._diagnosisNotification = _diagnosisNotification;
        this.running = true;
    }
    LastCoordinateDisplayComponent.prototype.ngOnInit = function () {
        if (this._coordinate === undefined) {
            this.observeRestart();
            this.observeVehicle();
            this.subscribeCoordinateResponse();
        }
    };
    Object.defineProperty(LastCoordinateDisplayComponent.prototype, "run", {
        get: function () {
            return this._run;
        },
        set: function (run) {
            this._run = run;
            if (!this._run) {
                this.running = false;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LastCoordinateDisplayComponent.prototype, "coordinate", {
        get: function () {
            return this._coordinate;
        },
        set: function (coordinate) {
            this._coordinate = coordinate;
        },
        enumerable: true,
        configurable: true
    });
    LastCoordinateDisplayComponent.prototype.observeRestart = function () {
        var _this = this;
        this._diagnosisNotification.restart$
            .subscribe(function () {
            _this.running = true;
        });
    };
    LastCoordinateDisplayComponent.prototype.observeVehicle = function () {
        var _this = this;
        this._diagnosisNotification.vehicle$
            .subscribe(function (vehicle) {
            _this.running = true;
        });
    };
    LastCoordinateDisplayComponent.prototype.subscribeCoordinateResponse = function () {
        var _this = this;
        this._diagnosisNotification.response$
            .filter(function (data) { return data instanceof Array; })
            .subscribe(function (coordinates) {
            _this._coordinate = coordinates[0].position;
            _this.running = false;
        });
    };
    LastCoordinateDisplayComponent.ctorParameters = function () { return [{ type: diagnosis_web_socket_service_1.DiagnosisWebSocketService }]; };
    return LastCoordinateDisplayComponent;
}());
exports.LastCoordinateDisplayComponent = LastCoordinateDisplayComponent;
//# sourceMappingURL=last-coordinate-display.component.js.map


// WEBPACK FOOTER //
// last-coordinate-display.component.js